import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {WorkflowInfo} from "common/flowmaster/types/workflow";

export type GetWorkflowsAction = {
  type: WorkflowsActionTypes["WORKFLOWS_FETCH"]["SUCCESS"];
  payload: WorkflowInfo[];
};

interface WorkflowFetchParams {
  fetch_data_assets?: boolean;
}

export default function getWorkflows(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOWS_FETCH,
    (organisationId: OrganisationId, params: WorkflowFetchParams = {}) => {
      return requestor
        .get(`${basePath}/organisation/${organisationId}/workflow`, {
          params,
          withCredentials: true,
        })
        .then(response => response.data);
    },
  );
}
